/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Sort_LabelInputs */

const fr_network_vehicle_sort_label = /** @type {(inputs: Network_Vehicle_Sort_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tri`)
};

const en_network_vehicle_sort_label = /** @type {(inputs: Network_Vehicle_Sort_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort`)
};

/**
* | output |
* | --- |
* | "Sort" |
*
* @param {Network_Vehicle_Sort_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_sort_label = /** @type {((inputs?: Network_Vehicle_Sort_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Sort_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_sort_label(inputs)
	return en_network_vehicle_sort_label(inputs)
});